export const MARKER = '\u23f1'; // stopwatch
